<div class="content-switch kh-medium-title-text bg-kh-grey-cool-light kh-grey-accessible
d-flex flex-row align-items-center justify-content-between">
    <div class="p-kh-3 d-flex flex-row align-items-center justify-content-between" *ngFor="let option of options" (click)="clickOption(option.id)" [ngClass]="{ active: activeId === option.id }">{{option.label}}</div>
</div>